/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaCheckboxText/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function TysiaCheckboxText({
  children,
  viewPath = "/DesignSystem/TysiaCheckbox/TysiaCheckboxText",
  marginLeft,
  color,
  size = "xmedium",
  textOverflow,
  order,
  whiteSpace,
  overflowX,
  text = "Default text",
  disabled,
  required
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtTysiacheckboxtextColorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaCheckboxText.color.primary.base'
        })
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let dtColorsRed600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.600'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={marginLeft || dtSpaceXxs}
 color={color || dtTysiacheckboxtextColorPrimaryBase}
 weight="regular"
 size={size}
 textOverflow={textOverflow}
 order={order}
 whiteSpace={whiteSpace}
 overflowX={overflowX}
 text={text}
 opacity={disabled ? 0.5 : 1}
/>
<fromFlow.When is={required}>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="*"
 marginLeft={dtSpaceXxxs}
 color={dtColorsRed600}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}